import {PostProvidersListParams} from 'domain/usecases/private/authorizations/post-providers-list';
import {makePostProvidersList} from 'main/factories/usecases/private/authorizations/post-providers-list-factory';

export const PostProvidersList = async (params: PostProvidersListParams, signal?: AbortSignal) => {
	const cleanProviders = params.prestadores.map(({idUnico: _idUnico, ...rest}) => rest);

	const response = await makePostProvidersList().post({
		nuControle: params.nuControle,
		prestadores: cleanProviders,
		signal,
	});

	return response;
};
